import API from 'services/api';

export const getProfileDetails = () => API.get('/api/profile/details').then(res => res?.data);
